<template>
  <div id="app">
    <header>
      <h1 class="title"><router-link to="/">Signe Okkels Larsen</router-link></h1>
      <div class="subtitle">
        Producer. Director. Editor.
      </div>
    </header>
    <nav>
      <div class="nav">
        <router-link to="/">Home</router-link>
        <router-link to="/about">About</router-link>
        <router-link to="/social">News & Social Media</router-link>
        <router-link to="/branded">Branded</router-link>
        <router-link to="/contact">Contact</router-link>
      </div>
      <div class="nav-mobile">
        <div class="nav-mobile-icon">
          <menu-icon size="3x" @click="menuOpen=true"></menu-icon>
        </div>
        <div class="nav-mobile-modal" v-if="menuOpen">
          <div class="nav-mobile-icon">
            <xicon size="3x" @click="menuOpen=false"></xicon>
          </div>
          <ul>
            <li @click="menuOpen=false"><router-link to="/">Home</router-link></li>
            <li @click="menuOpen=false"><router-link to="/about">About</router-link></li>
            <li @click="menuOpen=false"><router-link to="/social">News & Social Media</router-link></li>
            <li @click="menuOpen=false"><router-link to="/branded">Branded</router-link></li>
            <li @click="menuOpen=false"><router-link to="/contact">Contact</router-link></li>
          </ul>
        </div>
      </div>
    </nav>
    <router-view/>
    <footer>
      <ts-footer></ts-footer>
    </footer>
    <video-modal v-if="modal" :link="link" :size="size" @click="modal = false" />
  </div>
</template>

<script>
import VideoModal from '@/components/VideoModal.vue';
import { MenuIcon, XIcon } from 'vue-feather-icons'
import Footer from '@/components/Footer';

export default {
  components: {
    'video-modal': VideoModal,
    'ts-footer': Footer,
    'menu-icon': MenuIcon,
    'xicon': XIcon
  },
  data: function () {
    return {
      link: '',
      type: '',
      size: { height: 200, width: 200 },
      modal: false,
      menuOpen: false
    }
  },
  mounted() {
    this.$root.$on('playvideo', (type, link, size) => {
      this.link = link
      this.type = type
      this.size = size
      this.modal = true
    })
  }
}
</script>

<style lang="scss" scoped>
@import "src/theme.scss";

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: $black-color;
  width: 100vw;
}
header {
  margin-right: 60px;
  margin-left: 60px;
}
header a {
  text-decoration: none;
  color: $black-color;
}

.nav {
  padding: 30px;

  a {
    text-decoration: none;
    text-transform: uppercase;
    margin-right: 32px;
    font-weight: 500;

    color: $grey-500;

    &.router-link-exact-active {
      color: $black-color;
    }
  }
  a:hover {
    color: $black-color
  }
}
.nav-mobile-icon {
  position: absolute;
  top: 40px;
  left: 40px;
  color: #828282;
}
.nav-mobile-icon:hover {
  color: $black-color;
}
.nav-mobile-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: white;
}
ul {
  text-align: left;
  list-style: none;
  margin-top: 100px;
  max-width: 80vw;
}
li {
  padding: 16px 0 16px 48px;
  a {
    text-decoration: none;
    text-transform: uppercase;
    margin-right: 32px;
    font-weight: 500;
    font-size: 28px;

    color: #828282;
    &.router-link-exact-active {
      color: $black-color;
    }
  }
  a:hover {
    color: $black-color
  }
}
.subtitle {
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 1px;
  margin-top: 20px;
}
.title {
  font-size: 47px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 18px;
  margin-top: 60px;
}
@media only screen and (max-width: 875px) {
  .nav {
    display: none;
  }
  .title {
    margin-top: 120px
  }
}
@media only screen and (min-width: 876px) {
  .nav-mobile {
    display: none;
  }
}
</style>
